exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ClearPopup-module__move-wrapper___3Cb_B .ClearPopup-module__bottom-text___2_h5T{display:flex;justify-content:flex-end;align-items:center}.ClearPopup-module__move-wrapper___3Cb_B .ClearPopup-module__bottom-text___2_h5T p{font-size:12px}.ClearPopup-module__move-wrapper___3Cb_B .ClearPopup-module__bottom-text___2_h5T p:hover{cursor:pointer}.ClearPopup-module__move-wrapper___3Cb_B .ClearPopup-module__bottom-text___2_h5T .ClearPopup-module__red___1pIeD{color:red;margin:0 10px}", ""]);

// exports
exports.locals = {
	"move-wrapper": "ClearPopup-module__move-wrapper___3Cb_B",
	"bottom-text": "ClearPopup-module__bottom-text___2_h5T",
	"red": "ClearPopup-module__red___1pIeD"
};